import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "uv-tile-finance-label" }, "Finance", -1)
const _hoisted_2 = { class: "uv-tile-finance-value" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("sup", null, "$", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "/wk", -1)



	
export default /*#__PURE__*/_defineComponent({
  props: {
    weekly: null
  },
  setup(__props: any) {

const props = __props as {
		weekly: number
	}

	


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(props.weekly) + " ", 1),
      _hoisted_4
    ])
  ], 64))
}
}

})